import Hero from '../components/sections/Hero'
import TrustedBy from '../components/sections/TrustedBy'
import Solutions from '../components/sections/Solutions'
import About from '../components/sections/About'
import ContactCTA from '../components/sections/ContactCTA'

export default function Home() {
  return (
    <>
      <Hero />
      <TrustedBy />
      <Solutions />
      <About />
      <ContactCTA />
    </>
  )
}
